import MOModalWrapper from "../../../../components/commons/MOModalWrapper";
import { ErrorMessage, Field, Form, Formik } from "formik";
import MOButtonV2 from "../../../../components/commons/MOButtonV2";
import { useState } from "react";
import { toastMessage } from "../../../../helpers/toastMessage";
import mobioApi from "../../../../services";
import { safeJsonParse } from "../../../../utils/safeJsonParse";
import { formatDateForInput } from "../../../../utils/formatDateForInput";

const ExpireUpdateModel = ({
  modalOpen,
  setModalOpen,
  token,
  onboardingData,
  docData,
}) => {
  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);

    try {
      if (
        !docData?.doc?.id &&
        !docData?.doc?.onboardingDocId &&
        !docData?.replacement
      ) {
        toastMessage("error", "Kindly refresh the hold page");
      }

      const payload = {
        replacement: docData.replacement,
        onboardingDocId: docData?.doc?.onboardingDocId,
        networkDocId: docData?.doc?.id,
        data: values.expiry,
      };

      const api = mobioApi(token);
      const response = await api.onboardingDocExpiryInfoUpdate(payload);

      if (response?.data?.success) {
        onboardingData.onboardingDocs = onboardingData?.onboardingDocs?.map(
          (doc) => {
            if (docData?.doc?.onboardingDocId === doc?.id) {
              const previousData = safeJsonParse(doc.data);
              doc.data = JSON.stringify({
                ...previousData,
                [docData.replacement]: values.expiry,
              });
            }

            return doc;
          }
        );
      }

      toastMessage("success", response?.data?.msg);

      setModalOpen(false);
    } catch (error) {
      toastMessage("error", error?.response?.data?.msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <MOModalWrapper
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      title={`Edit ${docData?.doc?.name}-(${docData?.replacement})`}
      className={"country-city-modal header-modal-section"}
    >
      <div>
        <Formik
          initialValues={{
            expiry: docData?.doc?.existingData
              ? safeJsonParse(docData?.doc?.existingData)?.expiry
                ? formatDateForInput(
                    safeJsonParse(docData?.doc?.existingData)?.expiry
                  )
                : null
              : null,
          }}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, isSubmitting }) => (
            <Form>
              <div className="flex-1">
                <div className="input-field-md-lg">
                  <label>Expiry</label>
                  <Field
                    type="date"
                    name="expiry"
                    placeholder="Enter Expiry"
                    className="type-input-focus"
                    value={values.expiry}
                  />
                </div>
              </div>

              {/* Submit Button */}
              <div className="mt-20">
                <MOButtonV2
                  text={"UPDATE EXPIRY"}
                  type="submit"
                  textColor="#ffffff"
                  radius={4}
                  backgroundColor="#29AEE6"
                  height={44}
                  fontSize={11}
                  widthSize={"100%"}
                  padding={"16px 0px"}
                  disabled={isSubmitting}
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </MOModalWrapper>
  );
};

export default ExpireUpdateModel;
